import React, { useState } from 'react'
import './yearexperience.css'


const YearsExperience = () => {

    const sections = [
        {
            "id": "background",
            "title": "Background",
            "image": "/images/vision.png",
            "content": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
        },
        {
            "id": "vision",
            "title": "Our Vision",
            "image": "/images/vision-1.png",
            "content": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
        }
    ]

    const companyData = {
        year: '1991',
        founder: 'Rakesh panchal',
        role: 'CEO'
    }

    // Timeline data from the image
    const milestones = [
        { year: "1991", title: "Started Operations", description: "Company began its operations" },
        { year: "2006", title: "Moved to a Multi-Bank Platform", description: "Transitioned to a multi-bank platform for expanded services" },
        { year: "2010", title: "Non-Mutual expansion began", description: "Initiated expansion beyond mutual services" },
        { year: "2012", title: "Launched Loan Distribution", description: "Began loan distribution by leveraging agent networks" },
        { year: "2015", title: "Started Insurance Business", description: "Entered the insurance sector" },
        { year: "2023", title: "Started Wealth Business", description: "Launched wealth management services" },
        { year: "2024", title: "Chandran APP Launch & Real Estate", description: "Launched mobile app and entered real estate market" },
        { year: "2025", title: "Daburand 1.08L CR, of Licenses", description: "Achieved significant licensing milestone in FY 2024-25" },
        { year: "2026", title: "Daburand 3.10K CR, of Licenses", description: "Achieved significant licensing milestone in FY 2026" }
    ];

    const [activeMilestone, setActiveMilestone] = useState(milestones.length - 1);

    return (
        <div className="timeline-container">
            <header className="timeline-header">
                <h1>Krishna Finconcept Services</h1>
                <p>A journey of growth and expansion from 1991 to present</p>
            </header>

            {sections.map((section) => (
                <section key={section.id} className="content-section">
                    <div className='content' >
                        <h2 className="section-title">{section.title}</h2>
                        <p className="section-content">{section.content}</p>

                        {/* Additional details for specific sections */}
                        {section.id === "background" && (
                            <div className="highlight-box">
                                <p className="highlight-text">
                                    Founded in <strong>{companyData.year}</strong> by <strong>{companyData.founder}</strong> as a <strong>{companyData.role}</strong>
                                </p>
                            </div>
                        )}

                        {section.id === "vision" && (
                            <div className="achievement-box">
                                <div className="loan-amount">
                                    <h3>Annual Loan Disbursement</h3>
                                    {/* <div className="amount-display">{companyData.loanAmount}</div>
                                    <p className="amount-subtext">Processed through {companyData.stats?.partners} partners</p> */}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='image-content'>
                        <img src={section.image} width='100%' />
                    </div>
                </section>
            ))
            }


            <div className="timeline">
                {/* Timeline line */}
                <div className="timeline-line"></div>

                {/* Milestone markers */}
                {milestones.map((milestone, index) => (
                    <div
                        key={index}
                        className={`milestone${index === activeMilestone ? ' active' : ''}`}
                        onClick={() => setActiveMilestone(index)}
                    >
                        <div className='border-design'></div>
                        <div className="milestone-marker">
                            <div className="marker-dot"></div>
                            <div className="marker-year">{milestone.year}</div>
                        </div>


                        <div className="milestone-content">
                            <h3>{milestone.title}</h3>
                            <p>{milestone.description}</p>
                        </div>
                    </div>
                ))}
            </div>

            {/* Active milestone details */}
            {/* <div className="active-milestone-details">
                <h2>Current Highlight</h2>
                <div className="details-card">
                    <div className="details-year">{milestones[activeMilestone].year}</div>
                    <h3>{milestones[activeMilestone].title}</h3>
                    <p>{milestones[activeMilestone].description}</p>
                </div>
            </div> */}
        </div >
    );
};



export default YearsExperience